<template>
  <div class="form-check form-switch" v-if="valueModel">
    <input
      class="form-check-input"
      type="checkbox"
      :id="'switch-' + $.uid"
      v-model="valueModel.value"
      role="button"
    />
    <label class="form-check-label" :for="'switch-' + $.uid">{{ props.label }}</label>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed } from 'vue';

const model = defineModel<boolean>({ default: false, required: false });

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label?: string;
}>(), {
  label: '',
});

const { value } = props.valueKey !== undefined ? useField<boolean>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if (props.valueKey) return value;
  else if (model.value !== undefined) return model;
  else return undefined;
});
</script>
